import store from '@polleverywhere/redux'
import { slice as appSlice } from '../slices/app'
import { slice as profileSlice } from '@polleverywhere/redux/slices/profile'
import listenToSelector from './listen_to_selector'

export function setupDomainAuthCheck () {
  if (store.getState()[appSlice.name].options.extraDomainAuth) {
    return listenToSelector((state) => profileSlice.selectIsLoggedIn(state), (isLoggedIn) => {
      // Wait for the user to be logged in to rails before we bother checking other domains
      if (!isLoggedIn) return

      const { visualizations } = profileSlice.selectUserFeatures(store.getState())
      if (visualizations) {
        store.dispatch(appSlice.optionsUpdated({ test: true }))
        store.dispatch(appSlice.checkFullyLoggedIn())
      } else {
        store.dispatch(appSlice.optionsUpdated({ extraDomainAuth: false }))
      }
    })
  }
}
